module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/5@2x_2c7f446e2090ea25a2bf5fe2e7d0f444.png";